import constants from "../../common/restService/constant";
import GatewayGet from "../../common/restService/GatewayGet";

let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

export const getDdSCACData = async () => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "F4_CARRIERS_SCAC";
  inputObj["Input"] = JSON.stringify("");
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const getDdOPSSegmentData = async () => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "CARRIER_DROP_DOWN_OPS";
  inputObj["Input"] = JSON.stringify("");
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const getDdCountryData = async () => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "CARRIER_DROP_DOWN_LOC_V1";
  inputObj["Input"] = JSON.stringify("");
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  let countryDetails = [];
  result.forEach((eachCountry) => {
    countryDetails.push({
      ...eachCountry,
      countryCode: eachCountry["country"].split("-")[0],
      countryName: eachCountry["country"].split("-")[1],
    });
  });
  return countryDetails;
};

export const getDdRegionData = (data) => {
  let regionData = data;
  regionData = regionData.map((data) => ({
    geo: data["geo"],
    value: data["geo"],
  }));
  regionData = regionData.filter(
    (data, index, self) => index === self.findIndex((t) => t.geo === data.geo)
  );
  return regionData;
};

export const getTransportationModeData = async () => {
  inputObj["Activity"] = "F4_TRANSPORTATION_MODE";
  inputObj["Input"] = JSON.stringify("");
  props.input = inputObj;

  let result = await GatewayGet(props, props.input);
  result = result.map(r => ({...r, valueText: `${r['value']} - ${r['text']}`}));
  return result;
};

export const addEditDeleteCarrierContactTableRow = async (data) => {
  inputObj["Activity"] = "CARRIER_MASTER_DB_OPS_SPOT";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};
